import MainLayout from './main';
import LoginLayout from './login';

export {MainLayout, LoginLayout}



// WEBPACK FOOTER //
// ./components/layouts/index.js